export enum RootPathes {
  ROOT = '/',
  CONFIG = '/config',
  NEW_ASSET = '/new-asset',
}

export enum TabPathes {
  DASHBOARD = 'dashboard',
  DATA = 'data',
  ASSETS = 'assets',
  WALLET = 'wallet',
}

export enum AssetType {
  ALL = 'All',
  MEDIA = 'Media',
  DATASET = 'Dataset',
  AGENT = 'Agent',
  WIDGET = 'Widget',
  UTILITY = 'Utility',
  MODEL = 'Model',
}

export type OnboardingStep = {
  id: number;
  title: string;
  url: string;
  completed: boolean;
  description?: string;
  Icon: (props: any) => React.JSX.Element;
};

export type Tab = {
  id: number;
  label: string;
  path: string;
};

export type PlatformType = {
  label: string;
  value: string;
  icon: string;
};

export type Platform = {
  platform: string;
  value: string;
  icon: string;
  color: string;
  types: PlatformType[];
};

type BaseItem = {
  thumbnailUrl: string;
  title: string;
};

export type YtLikedVideoItem = BaseItem & {
  channelTitle: string;
  videoPublishedAt: string;
  description?: string;
};

export type YtSubscriptionItem = BaseItem & {
  channelId: string;
  subscribedAt: string;
  description?: string;
};

export type RecentlyPlayedItem = BaseItem & {
  name: string;
  url: string;
  artistName: string;
  artistUrl: string;
  albumName: string;
  albumUrl: string;
  popularity: number;
  playedAt: string;
};

export type DataType =
  | 'yt_liked_videos'
  | 'yt_subscriptions'
  | 'recently_played';

export type Source = {
  color: string;
  icon: string;
  name: string;
  path: string;
  disabled?: boolean;
  key: string;
  /** If true, connection shows a QR modal instead of opening an external OAuth URL */
  requiresQR?: boolean;
};

export type UserData = {
  youtubeConnected: boolean;
  redditConnected: boolean;
  spotifyConnected: boolean;
  twitchConnected: boolean;
  githubConnected: boolean;
  whatsappConnected: boolean;
  xConnected: boolean;
  walletAddress: string;
  telegramId: number;
  steamId: string | null;
  id: number;
  firstName: string | null;
  createdAt: string;
  updatedAt: string;
  firstLogin: boolean;
  onboardingCompleted: boolean;
  preferencesSet: boolean;
};

export type TokenData = {
  accessToken: string;
  refreshToken: string;
};

export type Option = {
  value: string;
  label: string;
};

export type Params = {
  page?: number;
  limit?: number;
};

export type StudioResponse<T> = {
  is_error: boolean;
  message: string;
  results: T;
};

export type PaginatedResponse<T> = {
  total: number;
  page: number;
  limit: number;
  results: T[];
};

export type AssetBase = {
  uuid: string;
  type: string;
  name: string;
  description: string;
  thumbnail: string;
  created_at: string;
};

export type AssetFull = AssetBase & {
  content_url: string;
  policy_source_url: string;
  stage: string;
  owner_id: number;
  updated_at: string;
};

export type GetAssetsResponse = StudioResponse<PaginatedResponse<AssetBase>>;

export type AssetDetailsResponse = StudioResponse<AssetFull>;

export type PriceHistoryItem = [number, number];

export type WalletInfo = {
  balance: number;
  price_history: PriceHistoryItem[];
};

export type Transaction = {
  transaction_type: string;
  status: string;
  amount: string;
  currency_type: string;
  description: string;
  created_at: string;
};

export type Tag = {
  name: string;
  uuid: string;
};

export type GetTagsResponse = StudioResponse<PaginatedResponse<Tag>>;

export type Preferences = {
  industriesToExclude: string[];
  countriesToExclude: string[];
  companySizesToExclude: string[];
  minOfferDaac: number;
  minOfferDurationMonths: number;
  consentDataCollection: boolean;
  consentRevocableAck: boolean;
  consentPolicyAck: boolean;
};

export type AssetsParams = Params & {
  asset_type?: string;
};
